import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { data } from '../../evn/evn';
import Sidebar from '../AdminComponents/SideBar';
import styles from './AppointmentManagement.module.css'; // Ensure this path matches your CSS file

const AppointmentManagement = () => {
  const [appointments, setAppointments] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchType, setSearchType] = useState('id');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAppointments = async () => {
      const ip = data.evn;
      const token = localStorage.getItem('adminToken');
      if (!token) {
        navigate('/.admin');
        return false;
    }

      try {
        const response = await axios.get(`${ip}/admin/appointments`, {
          headers: { 'x-auth-token': token },
        });
        setAppointments(response.data.appointments);
        setSearchResults(response.data.appointments);
      } catch (error) {
        console.error("There was an error fetching the appointments:", error);
      }
    };

    fetchAppointments();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    if (!event.target.value) {
      setSearchResults(appointments);
    } else {
      const filteredAppointments = appointments.filter(appointment =>
        searchType === 'id' ? appointment.id.toString().includes(event.target.value)
                            : appointment.user_id.toString().includes(event.target.value));
      setSearchResults(filteredAppointments);
    }
  };

  const handleSearchTypeChange = (event) => {
    setSearchType(event.target.value);
    setSearchTerm('');
    setSearchResults(appointments);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && searchTerm) {
      const exactMatchAppointments = appointments.filter(appointment => {
        if (searchType === 'id') return appointment.id.toString() === searchTerm;
        return appointment.user_id.toString() === searchTerm;
      });
      setSearchResults(exactMatchAppointments);
    }
  };

  return (
    <>
      <Sidebar />
      <div className={styles.container}>
        <div className={styles.searchContainer}>
          <select
            className={styles.searchTypeSelect}
            value={searchType}
            onChange={handleSearchTypeChange}
          >
            <option value="id">Search by ID</option>
            <option value="userId">Search by User ID</option>
          </select>
          <input
            type="text"
            placeholder={`Search by ${searchType}...`}
            value={searchTerm}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
            className={styles.searchInput}
          />
        </div>
        <table className={styles.table}>
          <thead>
            <tr className={styles.tableRow}>
              <th className={styles.tableHeader}>ID</th>
              <th className={styles.tableHeader}>User ID</th>
              <th className={styles.tableHeader}>Title</th>
              <th className={styles.tableHeader}>Case Title</th>
              <th className={styles.tableHeader}>Case Type</th>
              <th className={styles.tableHeader}>Contact Person</th>
              <th className={styles.tableHeader}>Location</th>
              <th className={styles.tableHeader}>Start Time</th>
              <th className={styles.tableHeader}>End Time</th>
              <th className={styles.tableHeader}>Email</th>
              
              <th className={styles.tableHeader}>Appointment Date</th>
            </tr>
          </thead>
          <tbody>
            {searchResults.map((appointment) => (
              <tr key={appointment.id} className={styles.tableRow}>
                <td className={styles.tableCell}>{appointment.id}</td>
                <td className={styles.tableCell}>{appointment.user_id}</td>
                <td className={styles.tableCell}>{appointment.title}</td>
                <td className={styles.tableCell}>{appointment.caseTitle}</td>
                <td className={styles.tableCell}>{appointment.caseType}</td>
                <td className={styles.tableCell}>{appointment.contactPerson}</td>
                <td className={styles.tableCell}>{appointment.location}</td>
                <td className={styles.tableCell}>{appointment.startTime}</td>
                <td className={styles.tableCell}>{appointment.endTime}</td>
                <td className={styles.tableCell}>{appointment.email}</td>
                
                <td className={styles.tableCell}>{appointment.appointmentDate}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
    </>
  );
};


export default AppointmentManagement;
     
